import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("mme_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("mme_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (service, vendor) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.service_id === service.id);
      if (existing) {
        return prev.map((i) =>
          i.service_id === service.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [
        ...prev,
        {
          service_id: service.id,
          vendor_id: vendor.id,
          vendor_name: vendor.name,
          name: service.name,
          price: service.price,
          unit: service.unit,
          image: service.image,
          quantity: 1,
        },
      ];
    });
    toast.success(`${service.name} added to cart`);
  };

  const removeItem = (serviceId) =>
    setItems((prev) => prev.filter((i) => i.service_id !== serviceId));

  const updateQty = (serviceId, qty) =>
    setItems((prev) =>
      prev
        .map((i) => (i.service_id === serviceId ? { ...i, quantity: Math.max(1, qty) } : i))
        .filter((i) => i.quantity > 0)
    );

  const clear = () => setItems([]);

  const addItems = (newOnes) => {
    setItems((prev) => {
      const map = new Map(prev.map((i) => [i.service_id, { ...i }]));
      (newOnes || []).forEach((it) => {
        if (!it.service_id) return;
        const ex = map.get(it.service_id);
        if (ex) ex.quantity += it.quantity || 1;
        else map.set(it.service_id, {
          service_id: it.service_id, vendor_id: it.vendor_id, vendor_name: it.vendor_name,
          name: it.name, price: it.price, unit: it.unit, image: it.image, quantity: it.quantity || 1,
        });
      });
      return Array.from(map.values());
    });
  };

  const replaceItems = (newItems) => setItems(Array.isArray(newItems) ? newItems : []);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, addItems, removeItem, updateQty, clear, replaceItems, subtotal, count }}
    >
      {children}
    </CartContext.Provider>
  );
}
